export const TRADE_OPTION_STATUS = {
  OPEN: 'open',
  EXPIRED: 'expired',
  SUCCESSFUL: 'successful',
  INVALID: 'invalid',
};

export const TRADE_STATUS = {
  OPEN: 'open',
  EXPIRED: 'expired',
  SUCCESSFUL: 'successful',
  INVALID: 'invalid',
};

export const TRADE_POSITION = {
  BUY: 'buy',
  SELL: 'sell',
};

export const ExworksKey = 'EXW';

export const convertTradeOptionStatusToString = code => {
  switch (code) {
    case TRADE_OPTION_STATUS.EXPIRED:
    case TRADE_STATUS.EXPIRED:
      return 'expired';
    case TRADE_OPTION_STATUS.SUCCESSFUL:
    case TRADE_STATUS.SUCCESSFUL:
      return 'successful';
    case TRADE_OPTION_STATUS.OPEN:
    case TRADE_STATUS.OPEN:
      return 'open';
    case TRADE_OPTION_STATUS.INVALID:
    case TRADE_STATUS.INVALID:
    default:
      return 'invalid';
  }
};

export const isOptionIncomplete = option => {
  if (
    option.trade_term &&
    option.pickup_gplace_name &&
    option.price_value &&
    option.price_currency &&
    option.origin_country &&
    option.shipment_date_ts &&
    option.packaging_type &&
    option.packaging_note &&
    option.quantity_value &&
    option.quantity_unit
  ) {
    return false;
  }
  return true;
};

export const translateTradeOptionStatus = (code, translations) =>
  translations[convertTradeOptionStatusToString(code)];



// WEBPACK FOOTER //
// ./app/utils/Trade/index.js